import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { InvestmentStatus } from '@common/enums/product-investment.enum';
import { DashboardService } from '@pages/dashboard/dashboard.service';
import { Observable, catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UpcomingProductGuard implements CanActivate {
  constructor(
    private router: Router,
    private dashboardService: DashboardService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean | UrlTree> | boolean | UrlTree {
    const id = Number(route.paramMap.get('id'));

    if (!id) {
      return true;
    }

    return this.dashboardService.getProductDetails(id).pipe(
      map(response => {
        if (response?.product?.investmentState === InvestmentStatus.UPCOMING) {
          return this.router.createUrlTree(['/dashboard/products']);
        }

        return true;
      }),
      catchError(() => of(true))
    );
  }
}
